import { render } from "./promotionSettings.vue?vue&type=template&id=3591b65f&scoped=true"
import script from "./promotionSettings.vue?vue&type=script&lang=js"
export * from "./promotionSettings.vue?vue&type=script&lang=js"

import "./promotionSettings.vue?vue&type=style&index=0&id=3591b65f&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "E:\\aliPro\\platformpro\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3591b65f"]])

export default __exports__